import React, { FC } from 'react';
import cx from 'classnames';
// @ts-ignore
import styles from './styles.module.css';

type Props = {
  label: string;
  icon?: JSX.Element;
  className?: string;
};

const DetailsLabel: FC<Props> = ({ label, icon, className }) => (
  <span className={cx(styles.detailsLabel, className)}>
    {icon} {label}
  </span>
);

export default DetailsLabel;
